import { useWizard } from 'react-use-wizard';

import Button from '../../generic/Button';
import { icons, IconText } from '../../generic/Icon';

import styles from './WelcomeStep.module.less';

/**
 * Pre-step rendered before the first question in the onboarding `SurveyWizard`.
 * Shows the FOSSA welcome hero, body copy, and a Start button that advances
 * the wizard via `useWizard().nextStep()`.
 */
export const WelcomeStep = () => {
  const { nextStep } = useWizard();
  return (
    <>
      <div className={styles.step}>
        <img src="/img/fossa-onboarding.gif" alt="Welcome to FOSSA" />
        <div className={styles.body}>
          To help you get the most from FOSSA, let&apos;s personalize your experience.
        </div>
      </div>
      <div className={styles.actions}>
        <Button onClick={() => nextStep()}>
          <IconText
            icon={icons.circlePlay}
            text="Start"
            alignIcon="right"
          />
        </Button>
      </div>
    </>
  );
};
